import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: [],
  allowedRoutes: [],
  isOwnerAdmin: false,
  loading: false,
  error: null,
};

const rolePermissionSlice = createSlice({
  name: "rolePermission",
  initialState,
  reducers: {
    setPermissions(state, action) {
      state.permissions = action.payload;
      state.loading = false;
    },
    setAllowedRoutes(state, action) {
      state.allowedRoutes = action.payload.allowedRoutes || [];
      state.isOwnerAdmin = action.payload.isOwnerAdmin || false;

      if (action.payload.permissions && action.payload.userRole) {
        state.permissions = [
          {
            role: action.payload.userRole,
            permissions: action.payload.permissions,
          },
        ];
      }
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setPermissions, setAllowedRoutes, setLoading, setError } =
  rolePermissionSlice.actions;
export default rolePermissionSlice.reducer;
